import { Injectable, NgModule, ModuleWithProviders, APP_INITIALIZER } from '@angular/core';
import { HttpModule, Http, ConnectionBackend, Request, RequestOptions, RequestOptionsArgs, Response, XHRBackend, Headers, RequestMethod, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { AdalService } from '../adal/adal.service';
import { AppSettingsService } from './appsettings.service';
import { ProgressBarService } from './progressbar.service'
import { ApiResponse } from '../models/api-response';

@Injectable()
export class AdalHttp extends Http {
    private currentRequests: number = 0;

    constructor(backend: ConnectionBackend,
        defaultOptions: RequestOptions,
        protected adalService: AdalService,
        protected adConfig: AppSettingsService,
        protected progressBarService: ProgressBarService
    ) {
        super(backend, defaultOptions);
        this.currentRequests = 0;
    }

    get(url: string, options?: RequestOptionsArgs): Observable<Response> {
        let options1 = new RequestOptions({ method: RequestMethod.Get });
        options1 = options1.merge(options);
        return this.sendRequest(url, options1);
    }

    post(url: string, body: any, options?: RequestOptionsArgs): Observable<any> {
        let options1 = new RequestOptions({ method: RequestMethod.Post, body: body });
        options1 = options1.merge(options);
        return this.sendRequest(url, options1);
    }

    delete(url: string, options?: RequestOptionsArgs): Observable<any> {
        let options1 = new RequestOptions({ method: RequestMethod.Delete });
        options1 = options1.merge(options);
        return this.sendRequest(url, options1);
    }

    patch(url: string, body: any, options?: RequestOptionsArgs): Observable<any> {
        let options1 = new RequestOptions({ method: RequestMethod.Patch, body: body });
        options1 = options1.merge(options);
        return this.sendRequest(url, options1);
    }

    put(url: string, body: any, options?: RequestOptionsArgs): Observable<any> {
        let options1 = new RequestOptions({ method: RequestMethod.Put, body: body });
        options1 = options1.merge(options);
        return this.sendRequest(url, options1);
    }

    head(url: string, options?: RequestOptionsArgs): Observable<any> {
        let options1 = new RequestOptions({ method: RequestMethod.Put });
        options1 = options1.merge(options);
        return this.sendRequest(url, options1);
    }

    private sendRequest(url: string, options: RequestOptionsArgs): Observable<Response> {
        this.incrementRequestCount();
        let options1 = new RequestOptions();
        options1.method = options.method;

        if (options.search != null) {
            options1.search = new URLSearchParams(options.search.toString()).clone();
        }

        if (options.headers != null) {
            options1.headers = new Headers(options.headers.toJSON());
        }

        if (options.body != null) {
            options1.body = options.body;
        }

        var resource = this.adalService.GetResourceForEndpoint(url);
        var authenticatedCall: Observable<any>;

        if (resource) {
            if (this.adalService.userInfo.isAuthenticated) {
                if (this.adalService.getCachedToken(resource)) {
                    authenticatedCall = this.adalService.acquireToken(resource)
                        .flatMap((token: string) => {
                            if (options1.headers == null) {
                                options1.headers = new Headers();
                            }
                            options1.headers.append('Authorization', 'Bearer ' + token);
                            return super.request(url, options1)
                                .map(response => this.extractData(response))
                                .do(this.decrementRequestCount)
                                .catch(err => { return this.handleError(err) });
                        });
                }
                else {
                    authenticatedCall = Observable.throw(new Error("User Access Token expired."));
                    authenticatedCall.subscribe(() => { },
                        err => {
                            this.decrementRequestCount();

                            setTimeout(() => {
                                this.adalService.logOut();
                            }, 5000);
                        });
                }
            }
            else {
                authenticatedCall = Observable.throw(new Error("User Not Authenticated."));
                authenticatedCall.subscribe(() => { },
                    err => {
                        this.decrementRequestCount();
                    });
            }
        }
        else {
            authenticatedCall = super.request(url, options).map(this.extractData).catch(this.handleError);
        }

        return authenticatedCall;
    }

    private extractData(response: Response) {
        this.decrementRequestCount();
        if (response.status < 200 || response.status >= 300) {
            throw new Error('Bad response status: ' + response.status);
        }

        var body;
        if (response.status != 204) {
            body = response.json();
        }

        var httpStatus = response.status;
        var notificationMessage = body ? (body.message ? body.message : " ") : response.statusText;
        this.handleResponse(httpStatus, notificationMessage);

        var apiResponse = new ApiResponse();

        apiResponse.statusCode = response.status;
        apiResponse.data = body;
        apiResponse.message = notificationMessage;
        return apiResponse;
    }

    private handleError(error: any) {
        this.decrementRequestCount();

        var httpStatus = error.status;
        var apiResponse = new ApiResponse();
        try {
            var responseMessage = JSON.parse(JSON.stringify(error._body ? error._body : error));
            var notificationMessage = responseMessage
                ? (responseMessage.message ? responseMessage.message : " ")
                : error.statusText;
            this.handleResponse(httpStatus, notificationMessage);
        
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        
        apiResponse.statusCode = error.status;
        apiResponse.reasonPhrase = error.statusText;
        apiResponse.isSuccess = false;
        apiResponse.data = responseMessage;
        } catch (e) {

        }
        return Observable.throw(apiResponse);
    }

    private decrementRequestCount() {
        if (--this.currentRequests == 0) {
        }
    }

    private incrementRequestCount() {
        if (this.currentRequests++ == 0) {
        }
    }

    private handleResponse(statusCode: number, notificationMessage: string) {
       
    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/services/adal.http.service.ts
 **/